import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ParamModel } from "app/model/cliente/param.model";
import ParamCompany from "app/model/cliente/ParamCompany.model";
import { ParamGroup } from "app/model/cliente/paramGroup.model";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class ParamsService {
  apiURL = environment.API;

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };

  constructor(private httpClient: HttpClient) {}

  saveParamGroup(paramGroup: ParamGroup): Observable<any> {
    const paramGroupJson = JSON.stringify(paramGroup);

    return this.httpClient.post<any>(
      this.apiURL + "/save-param-group/",
      paramGroupJson,
      this.httpOptions
    );
  }

  saveParam(param: ParamModel): Observable<any> {
    const paramJson = JSON.stringify(param);

    return this.httpClient.post<any>(
      this.apiURL + "/save-param/",
      paramJson,
      this.httpOptions
    );
  }

  getAllParamsGroups(): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + "/get-all-param-groups/",
      this.httpOptions
    );
  }

  getAllParamTypes(): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + "/get-all-param-types/",
      this.httpOptions
    );
  }

  getParamsByGroup(groupId: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + "/get-all-params-by-group/" + groupId,
      this.httpOptions
    );
  }

  getParamsByGroupAndCompany(
    groupId: number,
    companyId: "--TODAS--" | number
  ): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/get-params-by-group-and-company/${groupId}/${companyId}`,
      this.httpOptions
    );
  }

  saveParamValue(paramCompany: ParamCompany): Observable<ParamCompany> {
    return this.httpClient.post<ParamCompany>(
      this.apiURL + "/save-param-value",
      paramCompany,
      this.httpOptions
    );
  }

  findParamCompanyByCompanyIdAndParamId(
    companyId: number,
    paramId: number
  ): Observable<ParamCompany | null> {
    return this.httpClient.get<ParamCompany | null>(
      this.apiURL +
        `/get-param-company?companyId=${companyId}&paramId=${paramId}`,
      this.httpOptions
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/params/params.service.ts